var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.headLoading)?_c('b-progress',{staticClass:"header-progress-bar",attrs:{"animated":"","value":100,"variant":"primary"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }